<template>
  <div class="row mb-2">
    <div class="col-3">
      <h4>{{ $trans.get("__JSON__.Contracts") }}</h4>
    </div>    
    <div v-if="checkDisabled == false" class="col-9 text-end d-flex justify-content-end align-items-center">
      <div class="input-group me-2" style="width: max-content;">
        <span class="input-group-text">
          <span class="material-symbols-outlined">calendar_today</span>
        </span>
        <select id="date-dropdown" class="form-control" v-model="selectedYear">
          <option v-for="year in yearsList" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
      <button type="button" class="btn btn-primary mr-2" @click="resetVacations">
        {{ $trans.get("__JSON__.Recalculate vacation") }}
      </button>
      <button type="button" class="btn btn-primary" @click="addContract">
        {{ $trans.get("__JSON__.Add employeecontract") }}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
          <th>{{ $trans.get("__JSON__.Start") }}</th>
          <th>{{ $trans.get("__JSON__.End") }}</th>
          <th>{{ $trans.get("__JSON__.Probational period") }}</th>
          <th>{{ $trans.get("__JSON__.Exit") }}</th>
          <th>{{ $trans.get("__JSON__.Actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(contract, index) in contracts">
            <td>
              <input name="id[]" v-model="contract.id" type="hidden">
              <input name="no_probation_notification[]" v-model="contract.no_probation_notification" type="hidden">
              <input name="fixed_term[]" v-model="contract.fixed_term" type="hidden">
              <div class="input-group">
                <span class="input-group-text"><span class="material-symbols-outlined">
                    calendar_month
                  </span></span>
                <input type="date" class="form-control" id="startdate" name="start_at[]" autocomplete="off"
                  v-model="contract.start_at" :disabled="checkDisabled" />
              </div>
            </td>
            <td>
              <div class="input-group">
                <span class="input-group-text"><span class="material-symbols-outlined">
                    calendar_month
                  </span></span>
                <input type="date" class="form-control" id="enddate" name="end_at[]" autocomplete="off"
                  v-model="contract.end_at" :disabled="checkDisabled" />
              </div>
            </td>
            <td>
              <select class="form-control" id="probation_months" name="probation_months[]"
                v-model="contract.probation_months" :disabled="checkDisabled">
                <option value="-1">
                  {{ $trans.get("__JSON__.Choose") }}
                </option>
                <option value="0">
                  {{ $trans.get("__JSON__.None") }}
                </option>
                <option v-for="month in 4" :value="month + 2">
                  {{ month + 2 }} {{ $trans.get("__JSON__.months") }}
                </option>
              </select>
            </td>
            <td>
              <div class="input-group">
                <span class="input-group-text"><span class="material-symbols-outlined">
                    calendar_month
                  </span></span>
                <input type="date" class="form-control" id="exitdate" name="exit_at[]" autocomplete="off"
                  v-model="contract.exit_at" :disabled="checkDisabled" />
              </div>
            </td>
            <td>
              <button v-if="checkDisabled == false" type="button" :id="'delete_contract_' + index" class="btn btn-sm text-primary" @click="deleteContract(index)">
                <span class="material-symbols-outlined text-danger">
                  delete
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <Teleport to="body">
    <div class="modal" tabindex="-1" id="vacationscalulated">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1>{{ $trans.get('__JSON__.Recalculate vacations') }}</h1>
          </div>
          <div class="modal-body">
            <div v-if="showVacationData" v-for="year in yearsToDisplay" :key="year" class="year-item">
              <my-vacation-year :employee_id="employee_id" :year="String(year)" /> <br/>
            </div>
            <span>{{ $trans.get('__JSON__.successfully recalulated vacations') }}</span>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeVacationsCalulated">{{ $trans.get('__JSON__.close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import axios from "axios";

export default {
  name: "EmployeeContracts",
  created() {
    this.contracts = this.existing_contracts ?? []
    this.contracts.forEach((contract) => {
      contract.start_at = this.formatDate(contract.start_at)
      contract.end_at = this.formatDate(contract.end_at)
      contract.exit_at = this.formatDate(contract.exit_at)
    });

    this.old_data?.id?.forEach((value, index) => {
      if (!value) {
        this.addContract(
          this.old_data.start_at[index],
          this.old_data.end_at[index],
          this.old_data.exit_at[index],
          this.old_data.probation_months[index],
          this.old_data.no_probation_notification[index],
          this.old_data.fixed_term[index]
        );
      }
    });

  },
  props: {
    existing_contracts: Object,
    old_data: Object,
    employee_id: null,
    self: Boolean,
    bla: Boolean,
    own_employes_only_by_hr: Boolean,
  },
  data() {
    return {
      contracts: [],
      errors: [],
      yearsList: [],
      selectedYear: new Date().getFullYear(),
      currentYear: new Date().getFullYear(),
      stamp: [],
      showVacationData: false,
    };
  },
  computed: {
    checkDisabled() {
      if(this.own_employes_only_by_hr == 1 && this.self == 1 && !(this.can('own-employee-create'))) {
        return true;
      };
      return false;
    },
    yearsToDisplay() {
      if (!this.selectedYear) return [];      
      const years = [];
      for (let year = this.selectedYear; year <= this.currentYear; year++) {
        years.push(year);
      }
      return years;
    }
  },
  watch: {
  },
  mounted() {
    this.fetchStamp();
  },
  methods: {
    formatDate(date) {
      if (date == null) {
        return null;
      }
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    addContract(start_at = null, end_at = null, exit_at = 0, probation_months = -1, no_probation_notification = 0, fixed_term = 0) {
      this.errors = [];
      this.contracts.push({
        id: null,
        start_at: start_at,
        end_at: end_at,
        exit_at: exit_at,
        employee_id: this.employee_id,
        probation_months: probation_months,
        no_probation_notification: no_probation_notification,
        fixed_term: fixed_term
      });
    },
    deleteContract(index) {
      if (index > -1) {
        this.contracts.splice(index, 1)
      }
    },
    resetVacations() {
      axios
        .post("/api/employees/" + this.employee_id + "/recalculatevacations/" + this.selectedYear, {
          params: {
            employee_id: this.employee_id,
          },
        }) 
        .then((resp) => {
          this.showVacationData = true;
          $('#vacationscalulated').modal('show');
          console.log(resp.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeVacationsCalulated() {
      $('#vacationscalulated').modal('hide');
      this.showVacationData = false;
    },
    generateYearsList() {
      const startYear = this.stamp?.created_at.split("-")[0] ?? this.currentYear;
      this.yearsList = [];      
      for (let year = this.currentYear; year >= startYear; year--) {
        this.yearsList.push(year);
      }
    },
    fetchStamp() {
      console.log(this.employee_id);
      if (!this.employee_id) {
        return;
      }

      axios
        .get("/api/employees/" + this.employee_id + "/getoldeststamp")
        .then((resp) => {
          this.stamp = resp.data;
          this.generateYearsList();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },  
};
</script>

<style scoped></style>
